module.exports = __webpack_public_path__ + "static/assets/633ef8c7dee9f3eb793a73f5ef867e19.png";